import apiClient from '../../../common/functions/api_axios_instance.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const createRoleAssignment = async (data, { forApproval = false } = {}) => {
  try {
    const requestData = {
      user_id: data.user_id,
      role_id: data.role_id,
    };
    const path = forApproval
      ? '/systemInvoiceRoleManagement/assign'
      : '/systemInvoiceRoleManagement/assign-direct';
    const response = await apiClient.post(path, requestData);
    return { success: true, data: response.data };
  } catch (error) {
    console.log(error);
    const errorMessage =
      error.response?.data?.message || error.response?.data?.error || 'Failed to assign role';
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
